var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleArtLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 16,
    viewBox: "0 0 90 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_4298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19444 4.49483L12.9287 13.9616H3.46022L8.19444 4.49483ZM8.19444 0.0556641L0.25 15.9446H16.1389L8.19444 0.0556641Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1944 8.02148L5.92334 12.5502H10.4612L8.1944 8.02148Z",
    fill: "#EB008B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_721_4298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2575 1.00391H31.9126V15.0635H34.2575V1.00391Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6481 1.00391H38.3032V15.0635H40.6481V1.00391Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33 6.45591L32.7075 8.73633L33.4647 10.976L40.0873 8.69556L39.33 6.45591Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2476 1.02246H21.0107V3.38889H29.2476V1.02246Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3034 2.20703H23.9585V15.0496H26.3034V2.20703Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4607 15.9807L42.271 7.55169L47.4297 0.0917969L49.3503 1.44404L45.1556 7.51037L50.3441 14.5721L48.4607 15.9807Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4026 6.34863H43.7153V8.71506H49.4026V6.34863Z",
    fill: "#EB008B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_721_4298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7473 15.2816L61.1013 4.94472L57.6535 15.2623L55.3677 14.4796L59.9241 0.830801L60.9337 0.82309L62.2062 0.811523L67.0217 14.4603L64.7473 15.2816Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8738 11.0551L61.1982 9.35938L59.5226 11.0551L61.1982 12.7509L62.8738 11.0551Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5326 15.4439H69.1172V0.102539L78.2682 5.23047L71.5592 12.3749L71.5326 12.3479V15.4439ZM71.5326 4.2473V8.85473L74.367 5.8358L71.5326 4.2473Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4984 8.6636L71.7065 10.3027L76.7852 15.989L78.5771 14.3499L73.4984 8.6636Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.368 0.764648H79.8799V3.20909H88.368V0.764648Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3314 1.9873H82.916V15.2544H85.3314V1.9873Z",
    fill: "#EB008B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_4298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8718,
    height: 15.8889,
    fill: "white",
    transform: "translate(0.25 0.0556641)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_721_4298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.4681,
    height: 15.8165,
    fill: "white",
    transform: "translate(21.0107 0.0917969)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_721_4298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.1986,
    height: 15.7944,
    fill: "white",
    transform: "translate(55.3677 0.102539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleArtLogo);
export default __webpack_public_path__ + "static/media/scheduleArtLogo.71a51392891a45cefa6c9480de0abd89.svg";
export { ForwardRef as ReactComponent };